// services/statistics.service.js
import ApiService from './api.service';

const StatisticsService = {
    getStatistics: () => ApiService.fetch('statistics')
};

export default StatisticsService;